import React from 'react';

const ProfessionalVideosSection = React.memo(function ProfessionalVideosSection() {
    return (
        <div className="p-l5-16 p-l5-sm-48 section-2 section-dark-grey pb-l5-48">
            <div className="container">
                <div className="justify-content-center align-items-center">
                    <div className="d-flex flex-column align-items-start my-l5-48">
                        <h2>
                            Professional videos
                            <br />
                            without the drama
                        </h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            No scriptwriting background? No problem. Lumen5 makes video creation
                            feel as easy as building a slide.
                            <br />
                            No scripts, no learning curve — just drag, drop, and done.
                        </p>
                    </div>
                    <div className="border-video-container mb-l5-64">
                        <video
                            className="w-100"
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controls
                            aria-label="Explainer video - How Lumen5 helps your team create on-brand videos at scale."
                            poster="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/videos/landing_explainer/v2/Explainer.webp"
                        >
                            <source
                                src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/videos/landing_explainer/v2/Explainer.mp4"
                                type="video/mp4"
                            />
                            <source
                                src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/videos/landing_explainer/v2/Explainer.webm"
                                type="video/webm"
                            />
                        </video>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ProfessionalVideosSection;
